import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rel-interno d-flex flex-row align-items-center w-100" }
const _hoisted_2 = {
  class: "flex-column",
  style: {"width":"15%"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "flex-column",
  style: {"width":"70%"}
}
const _hoisted_5 = { class: "titulo mb-1" }
const _hoisted_6 = { class: "titulo2 mb-1" }
const _hoisted_7 = { class: "titulo3 mb-1" }
const _hoisted_8 = { class: "titulo4 mb-1" }
const _hoisted_9 = {
  key: 1,
  class: "flex-column",
  style: {"width":"70%"}
}
const _hoisted_10 = { class: "titulo mb-1" }
const _hoisted_11 = { class: "subtitulo" }
const _hoisted_12 = { class: "filtros" }
const _hoisted_13 = {
  class: "flex-column",
  style: {"width":"15%"}
}
const _hoisted_14 = { class: "usuario" }
const _hoisted_15 = { class: "data" }

import { onMounted, reactive, watch } from "vue";
import logo from "@/assets/images/favicon.png";

import { usuarioLogado } from "@/utils/funcoes";

import * as service from "@/services/paramsService";


export default /*@__PURE__*/_defineComponent({
  __name: 'Cabecalho',
  props: {
  Externo: { type: Boolean, required: true, default: false },
  Titulo: { type: String, required: false, default: "Não informado!" },
  Filtros: { type: String, required: false, default: "" },
},
  setup(__props) {


var props = __props;

var controle = reactive({
  externo: props.Externo,
  filtros: props.Filtros,
  titulo: props.Titulo,
  parametros: {} as service.Param,
  erro: "",
});

watch(() => props.Externo, async (novo) => {
  controle.externo = novo;
})

watch(() => props.Titulo, async (novo) => {
  controle.titulo = novo;
})

watch(() => props.Filtros, async (novo) => {
  controle.filtros = novo;
})

const obterParametros = () => {
  service.obter()
    .then((r) => {
      controle.parametros = r[0];
    })
    .catch((erro) => {
      setTimeout(() => {
        controle.erro = erro;
        obterParametros();
      }, 1000);
    });
};

onMounted(() => {
  obterParametros();
});

watch(
  () => props,
  (novo: any) => {
    controle.titulo = novo.Titulo;
    controle.filtros = novo.Filtros;
    obterParametros();
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "imagem",
        src: _unref(logo)
      }, null, 8, _hoisted_3)
    ]),
    (_unref(controle).externo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(controle).parametros.relatorioLinha1), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(controle).parametros.relatorioLinha2), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(controle).parametros.relatorioLinha3), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(controle).titulo), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(controle).parametros.relatorioLinha1), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(controle).titulo), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(controle).filtros), 1)
        ])),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(usuarioLogado)()?.usuarioId) + " - " + _toDisplayString(_unref(usuarioLogado)()?.nomeUsuario), 1),
      _createElementVNode("div", _hoisted_15, _toDisplayString(new Date().toLocaleString()), 1)
    ])
  ]))
}
}

})